import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container-fluid text-center">
        <p>Powered by Clorian</p>
      </div>
    </footer>
  );
};

export default Footer;
